<template>
  <div class="categories-with-products__product" ref="productCard">
    <a :href="product.link" @click="handleRedirect" class="categories-with-products__product-img-wrap">
      <img :src="product.image_url" alt="">
      <img class="h" :src="product.second_image_url" alt="">
    </a>
    <a :href="product.link" @click="handleRedirect" class="categories-with-products__product-title block-ellipsis block-ellipsis-truncate">{{ product.title }}</a>
    <div class="categories-with-products__product-bottom">
      <div class="categories-with-products__product-price-wrap">
        <template v-if="product.price.price_new !== product.price.price_old">
          <div v-if="product.price.price_new"
               class="categories-with-products__product-price categories-with-products__product-price--new"
          >
            {{ product.price.price_new }} грн
          </div>
          <div v-if="product.price.price_old"
               class="categories-with-products__product-price categories-with-products__product-price--old"
          >
            {{ product.price.price_old }} грн
          </div>
        </template>
        <div v-if="product.price.price_new === product.price.price_old"
             class="categories-with-products__product-price"
        >
          {{ product.price.price_new }} грн
        </div>
      </div>
      <BuyBtn
        :product-id="product.id"
        :code="product.code"
        :price="parseInt(product.price.price_new)"
        :btn-text="$t('add_to_cart')"
        size="medium"
        class="categories-with-products__product-btn-wrap"
      />
    </div>
  </div>
</template>

<script>
import BuyBtn from '@/components/cart/BuyBtn.vue'
import { GoogleEnhancedEcommerce } from '@/services/AnalyticService'

export default {
  name: 'ProductCardSimpleBig',
  components: { BuyBtn },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  methods: {
    async handleRedirect (event) {
      const { link } = event
      event.preventDefault()
      if (GoogleEnhancedEcommerce.isEnabled) {
        await GoogleEnhancedEcommerce.selectItem({
          'items': [GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(this.product.analytics_data[0])]
        })
      }
      location.href = link
    }
  },
  mounted () {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (GoogleEnhancedEcommerce.isEnabled) {
            this.$emit('onIntersecting', GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(this.product.analytics_data[0]))
          }
        }
      },
      { threshold: 0.2 }
    )
    observer.observe(this.$refs.productCard)
  }
}
</script>

<style lang="sass" scoped>
.categories-with-products
  &__product
    background-color: #fff
    border: 1px solid #E7E7E7
    border-radius: 5px
    padding: 10px 20px 15px
    display: flex
    flex-direction: column
    height: 100%
    box-sizing: border-box
    +mbetween($tablet--hor, $large)
      padding: 10px 12px 12px
    +mbetween($tablet, $tablet--hor)
      padding: 10px 12px 12px
    &-price
      color: #333
      font-size: 26px
      font-style: normal
      font-weight: 500
      line-height: normal
      +mbetween($large, $large--ext)
        font-size: 22px
      +mbetween($tablet--hor, $large)
        font-size: 20px
      +mbetween($small, $tablet--hor)
        font-size: 20px
      +mmax($small)
        font-size: 24px
      &-wrap
        display: flex
        flex-direction: column
      &--new
        color: #FF2F00
      &--old
        color: #909090
        font-size: 18px
        font-weight: 400
        text-decoration: line-through
        +mbetween($large, $large--ext)
          font-size: 20px
        +mbetween($tablet--hor, $large)
          font-size: 16px
        +mbetween($small, $tablet--hor)
          font-size: 16px
    &-bottom
      display: flex
      justify-content: space-between
      align-items: baseline
      margin-top: auto
      min-height: 56px
    &-title
      color: #333
      font-size: 18px
      font-weight: 400
      margin-bottom: 16px
      height: 69px
      text-decoration: none
      -webkit-line-clamp: 3
      +mbetween($tablet--hor, $large)
        font-size: 16px
        height: 66px
      +mbetween($small, $tablet--hor)
        font-size: 16px
        height: 66px
    &-img-wrap
      width: 200px
      height: 200px
      position: relative
      margin: 0 auto 1px
      text-decoration: none
      +mbetween($tablet--hor, $large)
        width: 150px
        height: 150px
      +mbetween($tablet, $tablet--hor)
        width: 150px
        height: 150px
      &:hover
        img
          display: none
          &.h
            display: block
      img
        position: absolute
        left: 50%
        top: 50%
        transform: translate(-50%, -50%)
        max-height: 100%
        &.h
          display: none
</style>
